<template>
  <div class="aboutPc">
    <div class="con">
      <div class="conItem backgroundWhite">
        <div class="container disFlex jusBetween">
          <div class="txt">
            <div class="title">优好医</div>
            <p>家庭医生团队，为家庭成员建立健康档案，提供全时段、立体化的健康评估、健康管理和基础诊疗方案，是全家人的健康守护者。</p>
            <div class="icons disFlex jusBetween alignItem">
              <span class="dian">
                <i></i>
                <i></i>
                <i></i>
              </span>
              <span class="line"></span>
            </div>
          </div>
          <img class="conImg" src="https://cdn.youjiajk.com/youhaoyi.png" alt="">
        </div>
      </div>
      <div class="conItem backgroundGray">
        <div class="container disFlex jusBetween">
          <img class="conImg" src="https://cdn.youjiajk.com/youhaohu.png" alt="">
          <div class="txt">
            <div class="title trr">优好护</div>
            <p class="tar">专业护士团队，满足线下医疗需求，提供陪诊、照护、垫付、康复指导等<br />多维服务，真正实现健康到家、健康到院、健康到店、健康到企业。</p>
            <div class="icons disFlex jusBetween alignItem">
              <span class="line" style="margin-left: 20px;width: 87%;"></span>
              <span class="dian">
                <i></i>
                <i></i>
                <i></i>
              </span>
            
            </div>
          </div>
        </div>
      </div>
      <div class="conItem backgroundWhite">
        <div class="container ">
          <div class="disFlex jusBetween">
            <div class="txt">
              <div class="title">优健管</div>
              <p>医护优选健管服务，含体检机构、齿科、眼科、中医理疗、疫苗预约等；与全球权威医疗专家联盟建立合作，直连美、日、欧洲机构，海外就医 轻松实现。</p>
              <div class="icons disFlex jusBetween alignItem">
              <span class="dian">
                <i></i>
                <i></i>
                <i></i>
              </span>
              <span class="line"></span>
            </div>
            </div>
            <img class="conImg" src="https://cdn.youjiajk.com/youjianguan.png" alt="">
          </div>
          <div class="subCon">
            <div class="subConItem">
              <img src="../../assets/image/tijian.png" />
              <p class="title">体检</p>
              <p class="subTxt">一站式预约、定制体检套餐、报告查询及检后系列健康管理服务等</p>
            </div>
            <div class="subConItem">
              <img src="../../assets/image/yanke.png" />
              <p class="title">眼科</p>
              <p class="subTxt">屈光视力检查、视力档案建立、用眼健康宣教、用眼专家指导、眼科疾病治疗等</p>
            </div>
            <div class="subConItem">
              <img src="../../assets/image/chike.png" />
              <p class="title">齿科</p>
              <p class="subTxt">挂号建档、全口检查、口腔全景片、超声波洁牙、牙齿抛光、齿科治疗及美容等</p>
            </div>
            <div class="subConItem">
              <img src="../../assets/image/zhongyi.png" />
              <p class="title">中医</p>
              <p class="subTxt">拔罐刮痧、肩颈调理、腰背调理、头部调理等中医医疗健康管理方案</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="conItem backgroundGray">
        <div class="container disFlex jusBetween">
          <img class="conImg" src="https://cdn.youjiajk.com/youhaoyao.png" alt="">
          <div class="txt">
            <div class="title trr">优好药</div>
            <p class="tar">健康商城满足系统定制化；自营药店及平台模式，品类丰富；<br /> 推出“药械+服务”组合包，通过医护优选供应链体系，<br/> 提供“有服务的好药”和“有服务的好械”。</p>
            <div class="icons disFlex jusBetween alignItem">
              <span class="line" style="width: 70%;margin-left: 120px;"></span>
              <span class="dian">
                <i></i>
                <i></i>
                <i></i>
              </span>
            </div>
          </div>
        </div>
      </div> -->
      <div class="conItem backgroundGray">
        <div class="container disFlex jusBetween">
          <div class="txt">
            <div class="title">优好保</div>
            <p>优加健康联合多家保司，合作推出“医-健-保”一站式创新保险产品；<br/> 多维产品矩阵，含场景险、消费险、带病体保险、人群保险等。</p>
            <div class="icons disFlex jusBetween alignItem">
              <span class="dian">
                <i></i>
                <i></i>
                <i></i>
              </span>
              <span class="line" style="width: 85%;margin-right: 38px;"></span>
            </div>
          </div>
          <img class="conImg" src="https://cdn.youjiajk.com/youhaobao.png" alt="">
        </div>
      </div>
      <div class="conItem backgroundWhite">
        <div class="container disFlex jusBetween">
          <img class="conImg" src="https://cdn.youjiajk.com/youhaofu.png" alt="">
          <div class="txt">
            <div class="title trr">优好付</div>
            <p class="tar">成熟的垫付业务系统，为保险公司提供线上、线下直付服务和垫付服务，<br />通过标准化流程、专业团队，高效完成风险控制和快速给付，<br/> 带给用户流畅体验。</p>
            <div class="icons disFlex jusBetween alignItem">
              <span class="line" style="width: 87%;margin-left: 15px;"></span>
              <span class="dian">
                <i></i>
                <i></i>
                <i></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .backgroundGray {
    background: #F8F9FD;
  }
  .backgroundWhite {
    background: #FFFFFF;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .disFlex {
    display: flex;
  }
  
  .jusBetween {
    justify-content: space-between;
  }

  .alignItem {
    align-items: center;
  }

  .tar{
    text-align: right;
  }

  .aboutPc {
    font-size: 14px;
    display: flex;
    flex-direction: column;

    
    .conItem {
      .container{
        padding: 122px 0 129px;
        .txt {
          width: 653px;
          .title {
            font-size: 40px;
            font-family: Source Han Sans CN, Source Han Sans CN-6;
            font-weight: 400;
            text-align: left;
            color: #333333;
            line-height: 60px;
            margin: 33px 0 20px;
          }
          .trr{
            text-align: right;
          }
          p{
            font-size: 20px;
            font-family: Source Han Sans CN, Source Han Sans CN-5;
            font-weight: 400;
            color: #363636;
            line-height: 30px;
          }
          .icons{
            margin-top: 41px;
            .dian{
              display: inherit;
              i{
                width: 6px;
                height: 6px;
                background: linear-gradient(180deg,#fd9353 0%, #fb5a29 73%);
                border-radius: 50%;
                margin-right: 8px;
                &:nth-child(2) {
                  opacity: 0.7;
                  background: linear-gradient(180deg,#fd9353 0%, #fb5a29 73%);
                }
                &:nth-child(3) {
                  opacity: 0.4;
                  background: linear-gradient(180deg,#fd9353 0%, #fb5a29 73%);
                }
              }
            }
            .line{
              display: inline-block;
              width: 90%;
              border-bottom: 1px solid #e6e6e6;
            }
          }
        }
        .conImg{
          width: 404px;
          height: 266px;
          
        }
        .subCon{
          display: flex;
          margin-top: 16px;
          .subConItem{
            width: 280px;
            height: 271px;
            background: #ffffff;
            border: 0.79px solid #eaeef0;
            border-radius: 6px;
            box-shadow: 0px 20px 30px 0px rgba(183,195,214,0.20); 
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: Source Han Sans CN, Source Han Sans CN-5;
            margin-right: 27px;
            padding: 0 20px;
            &:last-child{
              margin-right: 0;
            }
            img{
              width: 83px;
              height:83px;
              margin-top: 24px;
            }
            .title{
              font-size: 24px;
              font-weight: 500;
              text-align: left;
              color: #363636;
              line-height: 36px;
            }
            .subTxt{
              font-size: 16px;
              font-weight: 400;
              text-align: left;
              color: #666666;
              line-height: 28px;
              margin-top: 11px;
            }
          }
        }
      }
    }

  }
</style>


// WEBPACK FOOTER //
// src/views/pc/productPc.vue